// var API_DOMAIN = "https://zenonlinestore.zentexus.in/api";
// var API_DOMAIN = "http://localhost/zen_online_stores/api";

// export default API_DOMAIN;

const hostname = window.location.hostname;
const subdomain = hostname.split(".")[0];
const API_DOMAIN = `https://${subdomain}.zentexus.in/api`;
export default API_DOMAIN;
